// Keep in sync with the backend sunset deployment. Explicit false reopens UI.
export const salesClosed = process.env.VUE_APP_SALES_CLOSED !== 'false'
export const registrationClosed = process.env.VUE_APP_REGISTRATION_CLOSED !== 'false'

export function isNewPurchasePath(path: string): boolean {
  return /^\/(cart|add-to-cart|langganan|checkout|landing-page\/checkout-free|one-rupiah)(\/|$)/.test(path) ||
    /^\/webinar\/[^/]+\/?$/.test(path) || /^\/classroom\/[^/]+\/cart\/?$/.test(path)
}
